import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Waypoint, { above as waypointAbove } from 'react-waypoint';

import {
  exposeBuyButton,
  hideBuyButton,
  updateAccordion,
} from 'actions';

import { locale } from 'utils/locale';

import Compression from '../Compression/Compression';
import CoolByDesign from '../CoolByDesign/CoolByDesign';
import CrossSell from 'components/CrossSell/CrossSell';
import FaqsContainer from 'components/FaqsContainer/FaqsContainer';
import HundredNightTrial from 'components/HundredNightTrial/HundredNightTrial';
import IconProps from '../IconProps/IconProps';
import localize from 'components/Localize/Localize';
import MattressVariantPurchaser from '../MattressVariantPurchaser/MattressVariantPurchaser';
import PayBrightModal from 'components/PayBrightModal/PayBrightModal';
import ProductLifestyle from '../ProductLifestyle/ProductLifestyle';
import MattressThesis from '../MattressThesis/MattressThesis';
import TirelessImprovement from '../TirelessImprovement/TirelessImprovement';

import imageConfig from './imageConfig';
import translations from './translations';

const analyticsImpressionsProducts = [
  `Mattress Protector`,
  `Foundation`,
  `Bed Frame`,
];

class OverviewContainer extends React.Component {
  componentWillMount() {
    this.props.setAccordionInitialState(`mattress`, 0, true);
  }

  renderPayBrightModal() {
    if (!locale(this.props.locale).isEnCA()) {
      return null;
    }

    return <PayBrightModal />;
  }

  render() {
    return (
      <div>
        {this.renderPayBrightModal()}
        <MattressVariantPurchaser />
        <Waypoint
          onEnter={this.props.hideBuyButton}
          onLeave={this.props.exposeBuyButton}
          topOffset="100"
        />
        <IconProps
          iconProps={this.props.t.purchaserProps}
          id="iconProps"
        />
        <MattressThesis />
        <TirelessImprovement imageConfig={imageConfig.engineering} />
        <ProductLifestyle
          imageConfig={imageConfig.lifestyle}
          productType="mattress"
        />
        <CoolByDesign imageConfig={imageConfig.cool} />
        <Compression />
        <HundredNightTrial productType="mattress" />
        <CrossSell
          analyticsImpressionsProducts={analyticsImpressionsProducts}
          productType="mattress"
        />
        <FaqsContainer contentKey="mattress" />
      </div>
    );
  }
}

OverviewContainer.propTypes = {
  locale: PropTypes.string.isRequired,
  t: PropTypes.shape({
    purchaserProps: PropTypes.array,
  }),
};

const mapDispatchToProps = (dispatch) => ({
  exposeBuyButton: ({currentPosition}) => {
    if (currentPosition === waypointAbove) {
      dispatch(exposeBuyButton());
    }
  },
  hideBuyButton: () => {
    dispatch(hideBuyButton());
  },
  setAccordionInitialState: (accordion, key, show) => {
    dispatch(updateAccordion(accordion, key, show));
  },
});

export default connect(null, mapDispatchToProps)(localize(OverviewContainer, translations));
